import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Account } from './components/Accounts';
import { theme } from './theme';
import { ThemeProvider } from 'styled-components';
import Index from './components/index';
import SSOCallback from './components/SSOCallback';
import { ReactComponent as SVGSprite } from './assets/icons/icons.svg';

function App() {
  return (
    <Account>
      <ThemeProvider theme={theme}>
        <SVGSprite style={{ position: 'absolute', height: '0px', width: '0px' }} />
        <Router>
          <Routes>
            <Route path="/callback/:providerId" element={<SSOCallback />} />
            <Route path="/" element={<Index />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </Account>
  );
}

export default App;
